<div class="modal-body p-4">
  <div class="d-flex align-items-center gap-4">
    <div class="icon-container flex-shrink-0" ngbAutoFocus>
      @switch (type) {
        @case ("success") {
          <i class="bi bi-check-circle-fill text-success display-1 blink-animation"></i>
        }
        @case ("error") {
          <i class="bi bi-x-circle-fill text-danger display-1 blink-animation"></i>
        }
        @case ("warning") {
          <i class="bi bi-exclamation-circle-fill text-warning display-1 blink-animation"></i>
        }
        @case ("info") {
          <i class="bi bi-info-circle-fill text-info display-1 blink-animation"></i>
        }
        @default {

        }
      }
    </div>
    <div class="content-container flex-grow-1">
      @if (title) {
        <h3 class="mb-2">{{ title }}</h3>
      }
      <p class="text-body-secondary mb-4 pt-1">{{ content }}</p>
    </div>
  </div>
  <div class="mt-2">
    <div class="text-end">
      @if (type === "success") {
        <button type="button" class="btn btn-outline-primary px-4" (click)="close()">
          {{ confirmButtonMsg }}
        </button>
      } @else if (type === "error") {
        <button type="button" class="btn btn-outline-danger px-4" (click)="close()">
          {{ confirmButtonMsg }}
        </button>
      } @else {
        <button type="button" class="btn btn-outline-dark px-4" (click)="close()">
          {{ confirmButtonMsg }}
        </button>
      }
    </div>
  </div>
</div>
